export default {
    delete_sms_system_title: "Eliminar el Sistema SMS",
    delete_sms_system_success_message: "Se ha eliminado el Sistema SMS",
    delete_sms_system_error_message: "No es posible borrar el Sistema SMS",
    delete_sms_system_label: "¿Está seguro de que desea eliminar el Sistema SMS?",
}